import React, { useEffect } from "react";
import "./BurgerBody.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

const BurgerBody = () => {

    useEffect(() => {
        AOS.init();
      }, []);

  return (
    <>
      <div data-aos="fade" className="brgr_body">
        <div className="center_body">
            <div data-aos="fade-up" data-aos-delay="100" className="brgr_link"><Link to="/">Home</Link></div>
            <div data-aos="fade-up" data-aos-delay="200" className="brgr_link"><Link to="/resume">Resume</Link></div>
            <div data-aos="fade-up" data-aos-delay="300" className="brgr_link"><Link to="/projects">Projects</Link></div>
        </div>
      </div>
    </>
  );
};

export default BurgerBody;
